import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="131" height="130" viewBox="0 0 131 130" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="130" height="130" transform="translate(0.951904)" fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M93.8817 89.1833C90.0905 92.2316 85.2733 94.0557 80.0301 94.0557C67.8125 94.0557 57.9082 84.1514 57.9082 71.9339C57.9082 59.7163 67.8125 49.812 80.0301 49.812C92.2476 49.812 102.152 59.7163 102.152 71.9339C102.152 77.8537 99.8267 83.2304 96.0397 87.2005C99.6093 90.2522 106.646 96.1532 109.759 98.7635L109.76 98.7643L109.761 98.7653L110.388 99.2911C114.146 102.443 115.213 104.648 113.264 106.568C111.794 108.018 109.529 108.809 105.697 103.916C102.693 100.081 96.7206 92.5936 93.8817 89.1833Z"
          fill="#E8F0FF"
        />
        <path
          d="M28.6512 55.2542V43.8538C28.6512 41.0923 30.8898 38.8538 33.6512 38.8538H75.7957M28.6512 62.8186H47.7023C50.4637 62.8186 52.7023 65.0572 52.7023 67.8186V78.5294V84.4451"
          stroke="#E8F0FF"
        />
        <rect x="21.2776" y="31.3691" width="15.0082" height="15.0082" rx="3" fill="#E8F0FF" />
        <rect x="45.8253" y="12.7629" width="15.0082" height="15.0082" rx="3" fill="#E8F0FF" />
        <rect x="45.4373" y="54.6323" width="15.0082" height="15.0082" rx="3" fill="#E8F0FF" />
        <rect x="69.9025" y="31.3691" width="15.0082" height="15.0082" rx="3" fill="#E8F0FF" />
        <rect x="21.6351" y="54.6323" width="15.0082" height="15.0082" rx="3" fill="#E8F0FF" />
        <rect x="45.4373" y="76.6523" width="15.0082" height="15.0082" rx="3" fill="#E8F0FF" />
        <path
          d="M29.7572 53.7447V42.3442C29.7572 39.5828 31.9958 37.3442 34.7572 37.3442H76.9017M29.7572 61.3091H48.8082C51.5696 61.3091 53.8082 63.5477 53.8082 66.3091V77.0198V82.9356"
          stroke="#6C99F0"
        />
        <rect x="22.3835" y="29.8594" width="15.0082" height="15.0082" rx="3" fill="#4584FF" />
        <rect x="46.5432" y="11.4907" width="15.0082" height="15.0082" rx="3" fill="#4584FF" />
        <rect x="46.5432" y="53.1226" width="15.0082" height="15.0082" rx="3" fill="#4584FF" />
        <rect x="71.0084" y="29.8594" width="15.0082" height="15.0082" rx="3" fill="#4584FF" />
        <rect x="22.7411" y="53.1226" width="15.0082" height="15.0082" rx="3" fill="#4584FF" />
        <rect x="46.5432" y="75.1428" width="15.0082" height="15.0082" rx="3" fill="#4584FF" />
        <path d="M106.673 22.1028L111.945 27.375" stroke="#E8F0FF" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M111.945 22.1028L106.673 27.375" stroke="#E8F0FF" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M107.425 20.8164L112.542 25.9337" stroke="#FB8149" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M112.542 20.8162L107.425 25.9334" stroke="#FB8149" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M19.3616 84.2441L22.3835 87.2661" stroke="#E8F0FF" strokeLinecap="round" />
        <path d="M22.3835 84.2441L19.3616 87.2661" stroke="#E8F0FF" strokeLinecap="round" />
        <path d="M19.7666 83.4084L22.7886 86.4304" stroke="#FB8149" strokeLinecap="round" />
        <path d="M22.7886 83.4084L19.7666 86.4304" stroke="#FB8149" strokeLinecap="round" />
        <path d="M93.0256 104.491L97.7185 109.184" stroke="#E8F0FF" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M97.7184 104.491L93.0255 109.184" stroke="#E8F0FF" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M93.4344 103.516L98.1273 108.208" stroke="#FB8149" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M98.1272 103.516L93.4343 108.208" stroke="#FB8149" strokeWidth="1.5" strokeLinecap="round" />
        <g style={{ mixBlendMode: "multiply" }} opacity="0.8">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M80.3513 88.2684C90.1098 88.2684 98.0206 80.3576 98.0206 70.5991C98.0206 60.8406 90.1098 52.9298 80.3513 52.9298C70.5928 52.9298 62.682 60.8406 62.682 70.5991C62.682 80.3576 70.5928 88.2684 80.3513 88.2684ZM80.3513 93.7578C93.1415 93.7578 103.51 83.3893 103.51 70.5991C103.51 57.8089 93.1415 47.4404 80.3513 47.4404C67.5611 47.4404 57.1926 57.8089 57.1926 70.5991C57.1926 83.3893 67.5611 93.7578 80.3513 93.7578Z"
            fill="#E8F0FF"
          />
        </g>
        <circle opacity="0.9" cx="81.0933" cy="69.539" r="17.3229" fill="white" />
        <path
          d="M102.715 69.5388C102.715 81.4803 93.0347 91.1607 81.0933 91.1607C69.1519 91.1607 59.4714 81.4803 59.4714 69.5388C59.4714 57.5974 69.1519 47.917 81.0933 47.917C93.0347 47.917 102.715 57.5974 102.715 69.5388Z"
          stroke="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M81.0933 86.4171C90.4149 86.4171 97.9715 78.8604 97.9715 69.5388C97.9715 60.2173 90.4149 52.6606 81.0933 52.6606C71.7717 52.6606 64.2151 60.2173 64.2151 69.5388C64.2151 78.8604 71.7717 86.4171 81.0933 86.4171ZM81.0933 91.6607C93.3109 91.6607 103.215 81.7564 103.215 69.5388C103.215 57.3213 93.3109 47.417 81.0933 47.417C68.8757 47.417 58.9714 57.3213 58.9714 69.5388C58.9714 81.7564 68.8757 91.6607 81.0933 91.6607Z"
          fill="#FB8149"
        />
        <path
          d="M106.76 101.521C103.694 97.6062 97.5351 89.8867 94.7725 86.5816L96.82 84.5634C100.54 87.7506 108.713 94.5998 111.451 96.8961C115.21 100.048 116.276 102.253 114.327 104.174C112.857 105.623 110.592 106.414 106.76 101.521Z"
          fill="#FB8149"
        />
        <path d="M76.0109 64.2214L87.4424 75.7916" stroke="#4584FF" strokeWidth="2" strokeLinecap="round" />
        <path d="M87.5118 64.2908L75.9417 75.7223" stroke="#4584FF" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </>
  );
};
